export const AvailabilityKpi = {
  CURRENT: { id: 'current', unit: '%' },
  // MTD: { id: ' mtd', unit: '%' },
  // REFERENCE: { id: 'reference', unit: '%' },
};
